"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessInMicsFieldMapping = exports.ProcessInMicsFieldName = exports.DraftClaimFieldMapping = exports.DraftClaimFieldName = void 0;
var DraftClaimFieldName;
(function (DraftClaimFieldName) {
    DraftClaimFieldName["draftClaimRecordID"] = "draftClaimRecordID";
    DraftClaimFieldName["approvedLenderCode"] = "approvedLenderCode";
    DraftClaimFieldName["approvedLenderEnglishName"] = "approvedLenderEnglishName";
    DraftClaimFieldName["approvedLenderFrenchName"] = "approvedLenderFrenchName";
    DraftClaimFieldName["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    DraftClaimFieldName["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    DraftClaimFieldName["claimTypeCode"] = "claimTypeCode";
    DraftClaimFieldName["claimTypeIndicator"] = "claimTypeIndicator";
    DraftClaimFieldName["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    DraftClaimFieldName["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    DraftClaimFieldName["statusCode"] = "statusCode";
})(DraftClaimFieldName = exports.DraftClaimFieldName || (exports.DraftClaimFieldName = {}));
var DraftClaimFieldMapping;
(function (DraftClaimFieldMapping) {
    DraftClaimFieldMapping["draftClaimRecordID"] = "draftClaimRecordID";
    DraftClaimFieldMapping["approvedLenderCode"] = "lender.approvedLenderCode";
    DraftClaimFieldMapping["approvedLenderEnglishName"] = "lenderName.approvedLenderEnglishName";
    DraftClaimFieldMapping["approvedLenderFrenchName"] = "lenderName.approvedLenderFrenchName";
    DraftClaimFieldMapping["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    DraftClaimFieldMapping["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    DraftClaimFieldMapping["claimTypeCode"] = "detail.claimTypeCode";
    DraftClaimFieldMapping["claimTypeIndicator"] = "claimTypeIndicator";
    DraftClaimFieldMapping["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    DraftClaimFieldMapping["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    DraftClaimFieldMapping["statusCode"] = "profile.statusCode";
})(DraftClaimFieldMapping = exports.DraftClaimFieldMapping || (exports.DraftClaimFieldMapping = {}));
var ProcessInMicsFieldName;
(function (ProcessInMicsFieldName) {
    ProcessInMicsFieldName["draftClaimRecordID"] = "draftClaimRecordID";
    ProcessInMicsFieldName["approvedLenderCode"] = "approvedLenderCode";
    ProcessInMicsFieldName["approvedLenderEnglishName"] = "approvedLenderEnglishName";
    ProcessInMicsFieldName["approvedLenderFrenchName"] = "approvedLenderFrenchName";
    ProcessInMicsFieldName["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    ProcessInMicsFieldName["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    ProcessInMicsFieldName["claimTypeCode"] = "claimTypeCode";
    ProcessInMicsFieldName["claimTypeIndicator"] = "claimTypeIndicator";
    ProcessInMicsFieldName["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ProcessInMicsFieldName["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    ProcessInMicsFieldName["statusCode"] = "statusCode";
    ProcessInMicsFieldName["correspondenceLanguage"] = "correspondenceLanguage";
    ProcessInMicsFieldName["primaryBorrowerFirstName"] = "primaryBorrowerFirstName";
    ProcessInMicsFieldName["primaryBorrowerLastName"] = "primaryBorrowerLastName";
    ProcessInMicsFieldName["recordCreatedTimestamp"] = "recordCreatedTimestamp";
    ProcessInMicsFieldName["recordCreatedUserID"] = "recordCreatedUserID";
    ProcessInMicsFieldName["recordUpdatedUserID"] = "recordUpdatedUserID";
    ProcessInMicsFieldName["recordUpdatedUserFullName"] = "recordUpdatedUserFullName";
})(ProcessInMicsFieldName = exports.ProcessInMicsFieldName || (exports.ProcessInMicsFieldName = {}));
var ProcessInMicsFieldMapping;
(function (ProcessInMicsFieldMapping) {
    ProcessInMicsFieldMapping["draftClaimRecordID"] = "draftClaimRecordID";
    ProcessInMicsFieldMapping["approvedLenderCode"] = "lender.approvedLenderCode";
    ProcessInMicsFieldMapping["approvedLenderEnglishName"] = "lenderName.approvedLenderEnglishName";
    ProcessInMicsFieldMapping["approvedLenderFrenchName"] = "lenderName.approvedLenderFrenchName";
    ProcessInMicsFieldMapping["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    ProcessInMicsFieldMapping["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    ProcessInMicsFieldMapping["claimTypeCode"] = "detail.claimTypeCode";
    ProcessInMicsFieldMapping["claimTypeIndicator"] = "claimTypeIndicator";
    ProcessInMicsFieldMapping["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ProcessInMicsFieldMapping["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    ProcessInMicsFieldMapping["statusCode"] = "profile.statusCode";
    ProcessInMicsFieldMapping["correspondenceLanguage"] = "lender.correspondenceLanguageCode";
    ProcessInMicsFieldMapping["primaryBorrowerFirstName"] = "borrowers.0.firstName";
    ProcessInMicsFieldMapping["primaryBorrowerLastName"] = "borrowers.0.lastName";
    ProcessInMicsFieldMapping["recordCreatedTimestamp"] = "recordCreatedTimestamp";
    ProcessInMicsFieldMapping["recordCreatedUserFirstName"] = "recordCreatedUserFirstName";
    ProcessInMicsFieldMapping["recordCreatedUserID"] = "recordCreatedUserID";
    ProcessInMicsFieldMapping["recordUpdatedUserID"] = "recordUpdatedUserID";
    ProcessInMicsFieldMapping["recordUpdatedUserFullName"] = "recordUpdatedUserFullName";
})(ProcessInMicsFieldMapping = exports.ProcessInMicsFieldMapping || (exports.ProcessInMicsFieldMapping = {}));
